import { Typography } from '@breetometer/components';
import { RateCalculatorIcon } from 'BreetAssets';

import type { IExchangeInfoItemProps } from '../../DialogRateCalculator.helpers';

const ExchangeInfoItem = ({ label, value, variant, children }: IExchangeInfoItemProps) => (
	<div className='exchange-info-item'>
		<div className='exchange-info-item-left'>
			<RateCalculatorIcon
				variant={variant}
				className='svg-dark svg-dark-fill svg-dark-outline'
			/>
			<Typography className='color-primary-100'>{label}</Typography>
		</div>
		<div className='exchange-info-item-right'>
			<Typography className='color-neutral-50'>{value ?? children}</Typography>
		</div>
	</div>
);

export default ExchangeInfoItem;
